module.exports = __webpack_public_path__ + "img/打通客户微信.9e39190a.svg";